// src/js/components/accordion.js

export function initializeAccordions() {
    // Hitta alla accordion-knappar på sidan
    const accordions = document.querySelectorAll('.accordion-button');

    // Om inga accordions finns på denna sida, gör ingenting.
    if (accordions.length === 0) {
        return;
    }

    accordions.forEach(accordion => {
        accordion.addEventListener('click', () => {
            const panel = accordion.nextElementSibling;
            
            // Växla aktiv status på knappen
            const isActive = accordion.classList.toggle('active');

            // Sätt max-height för att skapa CSS-animationen
            if (isActive && panel) {
                panel.style.maxHeight = panel.scrollHeight + "px";
            } else if (panel) {
                panel.style.maxHeight = null;
            }
        });
    });

    console.log(`Accordion component initialized for ${accordions.length} element(s).`);
}